import Vue from 'vue'
import VueSvgIcon from 'vue-svgicon'
import 'vue-svgicon/dist/polyfill'
import { TippyComponent } from 'vue-tippy'
import { VueAxios } from '@/utils/request'

import NavigationMain from '@/components/NavigationMain'
import NavigationMobile from '@/components/NavigationMobile'
import NavigationFooter from '@/components/NavigationFooter'
import CookiePopup from '@/components/CookiePopup'
import PageNav from '@/components/PageNav'
import PageTools from '@/components/PageTools'
import ScrollTopBtn from '@/components/ScrollTopBtn/ScrollTopBtn.vue'
import CardSlider from '@/components/CardSlider/CardSlider.vue'
import CardSlide from '@/components/CardSlider/CardSlide.vue'
import { Slide, Slider } from '@/components/Slider'
import BlockContacts from '@/components/BlockContacts/BlockContacts.vue'

Vue.component('tippy-tooltip', TippyComponent)
Vue.component('navigation-main', NavigationMain)
Vue.component('navigation-mobile', NavigationMobile)
Vue.component('navigation-footer', NavigationFooter)
Vue.component('cookie-popup', CookiePopup)
Vue.component('page-nav', PageNav)
Vue.component('page-tools', PageTools)
Vue.component('scroll-top-btn', ScrollTopBtn)
Vue.component('block-contacts', BlockContacts)
Vue.component('card-slider', CardSlider)
Vue.component('card-slide', CardSlide)
Vue.component('slide', Slide)
Vue.component('slider', Slider)

Vue.use(VueAxios)

Vue.use(VueSvgIcon, {
    tagName: 'z-icon',
    classPrefix: 'z',
    isOriginalDefault: true
})

Vue.component('vue-raw', {
    props: ['raw'],
    render (h) {
        const div = document.createElement('div')
        div.innerHTML = this.raw
        return h(Vue.compile(div.outerHTML.replace(/\s{2,}/g, '')))
    }
})
